import ServiceRange from './ServiceRange';

export default ServiceRange;
